import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = ["onClick"]

import { ref, computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  paging: {
    type: Object,
    default: () => ({
      page: 1,
      totalPages: 0,
      size: 10,
      totalElements: 0,
      perPageOptions: [10, 25, 50, 100],
    }),
  },
  maxVisiblePages: Number,
  startAt: Boolean,
},
  emits: ["change", "next", "prev"],
  setup(__props, { emit }) {

const props = __props


const pagingVal = ref(props.paging);

const changePage = (val) => {
  pagingVal.value.page = props.startAt ? val - 1 : val;
  emit("change", pagingVal.value);
};

const activePage = computed(() => {
  console.log("start at", props.startAt);
  return props.startAt ? props.paging.page + 1 : props.paging.page;
});

const nextPage = () => {
  if (activePage.value < pagingVal.value.totalPages) {
    pagingVal.value.page++;
  }
  console.log(pagingVal.value);

  emit("next", pagingVal.value);
};
const prevPage = () => {
  if (pagingVal.value.page > 0) {
    pagingVal.value.page--;
  }
  emit("prev", pagingVal.value);
};

const visiblePages = computed(() => {
  const currentPage = activePage.value;
  const totalPages = pagingVal.value.totalPages;
  const maxVisible = props.maxVisiblePages;

  // Jika total halaman lebih sedikit dari yang ingin ditampilkan, tampilkan semua
  if (totalPages <= props.maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  // Hitung halaman awal dan akhir dari "jendela"
  let startPage = currentPage - Math.floor(props.maxVisiblePages / 2);
  let endPage = currentPage + Math.floor(props.maxVisiblePages / 2);

  // Koreksi jika jendela keluar dari batas awal (kurang dari 1)
  if (startPage < 1) {
    startPage = 1;
    endPage = props.maxVisiblePages;
  }

  // Koreksi jika jendela keluar dari batas akhir (lebih dari totalPages)
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = totalPages - maxVisible + 1;
  }

  // Buat array nomor halaman dari startPage ke endPage
  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return pages;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-item previous", { disabled: __props.startAt ? __props.paging.page === 0 : __props.paging.page === 1 }])
      }, [
        _createElementVNode("a", {
          class: "page-link",
          style: {"cursor":"pointer"},
          onClick: prevPage
        }, " Previous ")
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visiblePages), (pageNumber) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["page-item", { active: pageNumber === _unref(activePage) }]),
          key: pageNumber
        }, [
          _createElementVNode("a", {
            class: "page-link",
            style: {"cursor":"pointer"},
            onClick: ($event: any) => (changePage(pageNumber))
          }, _toDisplayString(pageNumber), 9, _hoisted_2)
        ], 2))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item next", {
          disabled: __props.startAt
            ? __props.paging.page + 1 === __props.paging.totalPages
            : __props.paging.page === __props.paging.totalPages,
        }])
      }, [
        _createElementVNode("a", {
          class: "page-link",
          style: {"cursor":"pointer"},
          onClick: nextPage
        }, " Next ")
      ], 2)
    ])
  ]))
}
}

})